module.exports = __webpack_public_path__ + "assets/icon-vegetationHeight-low.106ca6d0.svg";